var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNopat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9381_9952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 10.6667C9.99984 13.245 7.91147 15.3333 5.33317 15.3333C2.75487 15.3333 0.666504 13.245 0.666504 10.6667C0.666504 8.08837 2.75487 6 5.33317 6C7.91147 6 9.99984 8.08837 9.99984 10.6667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50357 9.42703C6.50357 9.42703 6.12004 8.65503 5.2936 8.65503C4.32364 8.65503 3.87826 9.91943 4.78882 10.3772C5.24906 10.6098 6.4813 10.7286 6.45655 11.7257C6.42686 12.859 4.61067 13.0272 4.16528 11.8519",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 8.67486V7.59851",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 13.7375V12.6611",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.33329C8 2.30778 9.64116 0.666626 11.6667 0.666626C13.6922 0.666626 15.3333 2.30778 15.3333 4.33329C15.3333 6.3588 13.6922 7.99996 11.6667 7.99996",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3238 5.33337L11.3333 7.90641L13.3333 9.33337",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9381_9952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNopat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nopat.2b9d6870.svg";
export { ForwardRef as ReactComponent };